import { useEffect, useRef, useState } from "react";

import InlineImageGallery from "../../../shared/inlineImageGallery/InlineImageGallery";
import PublicPresentationLightbox from "./PublicPresentationLightbox";
import { orderPresentationMedia } from "../lib/presentationMedia";

function mediaAlt(item, fallbackIndex) {
  if (item && item.kind === "plan") return "Планування";
  return `Фото ${fallbackIndex + 1}`;
}

function clampIndex(index, length) {
  if (!length) return 0;
  if (!Number.isFinite(Number(index))) return 0;
  return Math.min(Math.max(Number(index), 0), length - 1);
}

function toGalleryItems(ordered) {
  return ordered.map((item, index) => ({
    id: `media-${item.position}-${item.url}`,
    src: item.url,
    alt: mediaAlt(item, index),
    kind: item.kind || "image",
    badge: item.kind === "plan" ? "План" : "Фото",
  }));
}

function PublicPresentationGallery({ media }) {
  const { ordered } = orderPresentationMedia(media);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const heroTriggerRef = useRef(null);

  useEffect(() => {
    setActiveIndex((current) => clampIndex(current, ordered.length));
  }, [ordered.length, media]);

  const safeActive = clampIndex(activeIndex, ordered.length);

  const selectHero = (index) => {
    setActiveIndex(clampIndex(index, ordered.length));
  };

  const openLightbox = () => {
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  return (
    <section className="presentation-gallery" aria-label={ordered.length ? "Галерея" : "Медіа"}>
      <InlineImageGallery
        className="presentation-gallery__inline"
        items={toGalleryItems(ordered)}
        activeIndex={safeActive}
        onActiveIndexChange={selectHero}
        onHeroClick={ordered.length ? openLightbox : undefined}
        heroTriggerRef={heroTriggerRef}
        emptyLabel="Фото не додано"
        ariaLabel="Галерея"
        testIds={{
          hero: "presentation-gallery-hero",
          prev: "presentation-gallery-prev",
          next: "presentation-gallery-next",
          thumb: (index) => `presentation-gallery-thumb-${index}`,
        }}
      />
      <PublicPresentationLightbox
        items={ordered}
        activeIndex={lightboxOpen ? safeActive : null}
        onClose={closeLightbox}
        onIndexChange={selectHero}
        restoreFocusRef={heroTriggerRef}
      />
    </section>
  );
}

export default PublicPresentationGallery;
